<div class="stacked-notifications-container">
  <div
    *ngFor="let notification of notifications; let i = index"
    class="notification-item"
    [style.z-index]="notifications.length - i"
  >
    <div class="order-snackbar-card" [ngClass]="{'rejected-notification': isRejected(notification)}">
      <div class="order-snackbar-header" [ngClass]="{'rejected-header': isRejected(notification)}"></div>

      <div class="order-snackbar-content p-24">
        <div class="order-snackbar-tag-row">
          <span class="order-snackbar-tag">
            {{ getTagLabel() }}
          </span>
        </div>

        <!-- Mismo criterio que show-notifications: timeline solo si hay avance (nunca REJECTED); `step.svg` en todos los pasos no futuros -->
        <div *ngIf="hasOrderTimeline(notification)" class="order-timeline" aria-hidden="true">
          <!-- Fila 1: círculos + conectores -->
          <div class="order-timeline__circles-row">
            <ng-container *ngFor="let step of orderTimelineSteps; let i = index; let last = last">
              <div class="order-timeline__circle-wrap">
                <div class="order-timeline__circle"
                  [class.order-timeline__circle--future]="isOrderTimelineFutureStep(notification, i)">
                  <img *ngIf="!isOrderTimelineFutureStep(notification, i)" class="order-timeline__step-icon" src="assets/svg/step.svg" width="24" height="24" alt="">
                  <span *ngIf="isOrderTimelineFutureStep(notification, i)" class="order-timeline__step-num">{{ i + 1 }}</span>
                </div>
              </div>
              <div *ngIf="!last" class="order-timeline__connector"
                [class.order-timeline__connector--done]="isOrderTimelineConnectorDone(notification, i)"></div>
            </ng-container>
          </div>
          <!-- Fila 2: etiquetas -->
          <div class="order-timeline__labels-row">
            <ng-container *ngFor="let step of orderTimelineSteps; let i = index; let last = last">
              <div class="order-timeline__label-col"
                [class.order-timeline__label-col--first]="i === 0"
                [class.order-timeline__label-col--last]="last">
                <span class="order-timeline__label"
                  [class.order-timeline__label--active]="isOrderTimelineStepLabelActive(notification, i)">{{ step.label }}</span>
              </div>
              <div *ngIf="!last" class="order-timeline__label-spacer"></div>
            </ng-container>
          </div>
        </div>

        <p class="title fts-16 font-bold-dali m-0 p-0">
          {{ notification.title }}
        </p>
        <p class="subtitle fts-14 font-regular color-subTitle-custom m-0 pt-0 pl-0 pr-0 pb-16">
          {{ orderNotificationSubtitle(notification) }}
        </p>
        <div class="actions">
          <span class="order-snackbar-date" *ngIf="getFormattedDate(notification)">
            {{ getFormattedDate(notification) }}
          </span>
          <button class="btn-text fts-14 font-semiBold" (click)="close(notification)">Cerrar</button>
          <button class="btn-link fts-14 font-semiBold d-flex align-items-center" (click)="goToOrder(notification)">
            Ver detalles  <img
            class="ml-8"
                src="assets/image/icon-arrowRight_red.svg"
                width="18"
                height="16"
                alt>
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
